<template>
  <DialogTemplate :show-controls="true" class="dialog-avatars">
    <template #header>
      <h4>{{ $t('delete.popin.title') }}</h4>
    </template>
    <p class="description">{{ $t('delete.popin.description') }}</p>
    <div class="form form-field form-field-text small form-secondary">
      <input
        id="delete"
        v-model="model"
        name="delete"
        role="delete"
        type="text"
        @keydown.enter="emit('confirm')"
      />
    </div>
    <p class="instruction">{{ $t('delete.popin.instruction') }}</p>
    <template #footer>
      <DialogUiConfirm
        :enable="enable"
        @confirm="emit('confirm')"
        @cancel="emit('cancel')"
      />
    </template>
  </DialogTemplate>
</template>
<script lang="ts" setup>
const emit = defineEmits(["cancel", "confirm"]);
const model = defineModel<string>({ default: '' });

const enable = computed(() => {
  return model.value === 'SUPPRIMER';
});
</script>
<style lang="scss" scoped>
.form {
  width: 100%;
}
.description {
  @include font('n', 700);
}
.instruction {
  @include font('s', 400);
}
</style>
